var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.66667C0 0.744792 0.89375 0 2 0H26C27.1063 0 28 0.744792 28 1.66667C28 2.58854 27.1063 3.33333 26 3.33333H2C0.89375 3.33333 0 2.58854 0 1.66667ZM0 10C0 9.07812 0.89375 8.33333 2 8.33333H26C27.1063 8.33333 28 9.07812 28 10C28 10.9219 27.1063 11.6667 26 11.6667H2C0.89375 11.6667 0 10.9219 0 10ZM28 18.3333C28 19.2552 27.1063 20 26 20H2C0.89375 20 0 19.2552 0 18.3333C0 17.4115 0.89375 16.6667 2 16.6667H26C27.1063 16.6667 28 17.4115 28 18.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderRight);
export default __webpack_public_path__ + "static/media/header-right.35c8ab436eac96fdf428becb6f6acc6a.svg";
export { ForwardRef as ReactComponent };